export const locale = {
  lang: 'it',
  data: {
    NEW_COMPANY_DIALOG: {
      NEW: 'Nuovo',
      CANCEL: 'Annulla',
      SAVE: 'Salva',
      CONTACT_DATA: 'Dati referente',
      COMPANY: {
        BUSINESS_NAME: 'Nome azienda',
        TAX_CODE_PREFIX: 'Nazione',
        TAX_CODE: 'Codice Fiscale',
        LAST_NAME: 'Cognome',
        FIRST_NAME: 'Nome',
        PHONE: 'Telefono',
        EMAIL: 'Email',
        NOTE: 'Note',
      },
      ADDRESS: {
        TITLE: 'Indirizzo',
        ADDRESS_1: 'Via',
        CITY: 'Città',
        STATE: 'Provincia',
        ZIP: 'CAP',
        COUNTRY: 'Nazione',
        PHONE: 'Telefono',
        FAX: 'Fax',
      },
      ERROR: {
        REQUIRED: 'Campo obbligatorio',
        WRONG_FORMAT: 'Formato errato',
        TAX_CODE_ALREADY_USED: 'Codice Fiscale già usato',
        INVALID_EMAIL: 'Email non valida',
        SAVE_ERROR: 'Errore: azienda non salvata... Riprova!',
      },
    },
  },
};
